import React from 'react';
import { motion } from 'framer-motion';
import { HeartHandshakeIcon, CloudIcon, HandIcon, HomeIcon, LockIcon, SparklesIcon, EyeIcon } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
export function AudienceSection() {
  const audience = [{
    text: 'está casada, convive o tiene una relación estable,',
    icon: HeartHandshakeIcon
  }, {
    text: 'siente una soledad profunda dentro de su relación,',
    icon: CloudIcon
  }, {
    text: 'ha sostenido demasiado durante demasiado tiempo,',
    icon: HandIcon
  }, {
    text: 'teme romper el hogar, pero también teme seguir desapareciendo dentro de él,',
    icon: HomeIcon
  }, {
    text: 'necesita respuestas privadas, honestas y emocionalmente seguras,',
    icon: LockIcon
  }, {
    text: 'desea recuperar conexión o, al menos, claridad para decidir.',
    icon: SparklesIcon
  }];
  const realities = ['donde hay historia,', 'donde hay rutina,', 'donde hay hijos o responsabilidades,', 'donde hay miedo,', 'donde hay culpa,', 'donde hay desgaste,', 'y donde aun así necesitas verdad.'];
  return <section className="py-8 md:py-12 px-6 bg-[#FEF0F0]" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-57">
            PARA QUIÉN ES ESTA GUÍA
          </h2>

          <p className="text-lg text-mutedBrown mb-6" data-id="element-58">
            Esta guía es para ti si eres una mujer que:
          </p>

          <ul className="space-y-4" data-id="element-59">
            {audience.map((item, index) => {
            const Icon = item.icon;
            return <li key={index} className="flex items-start gap-3" data-id="element-60">
                  <Icon className="w-5 h-5 text-terracotta flex-shrink-0 mt-1" data-id="element-61" />
                  <span className="text-lg text-warmBrown" data-id="element-62">{item.text}</span>
                </li>;
          })}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-63">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center" data-id="element-64">
            POR QUÉ ESTA GUÍA SE SIENTE DIFERENTE
          </h2>

          <div className="space-y-4 text-lg text-mutedBrown leading-relaxed" data-id="element-65">
            <p data-id="element-66">
              Porque no te habla desde el juicio. No te habla desde el extremo.
              No te habla como si tu vida fuera simple.
            </p>
            <p data-id="element-67">Te habla desde un lugar real:</p>

            <ul className="space-y-2 pl-6 border-l-2 border-softGold/50 italic text-warmBrown" data-id="element-68">
              {realities.map((item, index) => <li key={index} data-id="element-69">{item}</li>)}
            </ul>

            <div className="pt-4 space-y-3" data-id="element-70">
              <p data-id="element-71">Esta guía no vende solo esperanza.</p>
              <p className="font-medium text-xl text-terracotta" data-id="element-72">
                También te entrega comprensión.
              </p>
              <p data-id="element-73">Y eso, en un momento como este, vale muchísimo.</p>
            </div>
          </div>

          <div className="mt-8" data-id="element-74">
            <CTAButton text="QUIERO CLARIDAD EMOCIONAL REAL" icon={<EyeIcon className="w-5 h-5" data-id="element-76" />} data-id="element-75" />
          </div>
        </motion.div>
      </div>
    </section>;
}